import { ISelectedData, ITreeItem, ITreeItemES } from "../interfaces/tree";
import { EtySchool } from "../interfaces/entities";

interface ISetItemsRecursiveArgs {
    type: 'school';
    items: EtySchool[];
    onClickItem: (item: ITreeItem) => void;
    selected: ISelectedData | null;
    expanded: ITreeItemES[];
    parentMethod: null;
    lastLevel: number;
};
export const setItemsRecursive = (args: ISetItemsRecursiveArgs): ITreeItem[] => {
    const { type, items, onClickItem, selected, expanded, parentMethod, lastLevel } = args;

    const oItems: ITreeItem[] = [];

    for (const item of items) {
        const newObject: ITreeItem = {
            type: type,
            id: item.id,
            level: 0,
            onClickItem: onClickItem,
            data: item,
            name: "",
            method: null,
            parentMethod: parentMethod,
            children: [],
            selected: false,
            expanded: false,
            lastLevel: lastLevel,
        };

        if (type === 'school') {
            newObject.name = (item as EtySchool).name;
            newObject.selected = selected?.level === 0 && selected?.id === item.id;
            newObject.expanded = !!expanded.find(i => i.level === 0 && i.id === item.id);
            newObject.method = null;
            newObject.parentMethod = null;
            newObject.lastLevel = lastLevel;
        }

        oItems.push(newObject);
    };

    return oItems;
};

export const findItemRecursive = (items: ITreeItem[], id: number, level: number): ITreeItem | undefined => {
    let item;
    for (const element of items) {
        if (element.id === id && element.level === level) {
            item = element;
            break;
        } else if (element.children.length > 0) {
            item = findItemRecursive(element.children, id, level);
            if (item) {
                break;
            };
        }
    }
    return item;
};

export const resetSelected = (items: ITreeItem[]): ITreeItem[] => {
    const newItems = [...items];

    newItems.forEach(item => {
        item.selected = false;

        if (item.children.length > 0) {
            resetSelected(item.children);
        };
    });

    return newItems;
};

export const removeTemporaryItems = (items: ITreeItem[]): ITreeItem[] => {
    const newItems = items.filter(item => item.id > 0);

    newItems.forEach(item => {
        if (item.children.length > 0) {
            item.children = removeTemporaryItems(item.children);
        };
    });

    return newItems;
};